// extracted by mini-css-extract-plugin
module.exports = {"headerColumn":"style_headerColumn__fRmCt","rowColumn":"style_rowColumn__2MQzO","center":"style_center__2C3Nt"};